import script from "./Gartenkultur-Company.vue?vue&type=script&setup=true&lang=js"
export * from "./Gartenkultur-Company.vue?vue&type=script&setup=true&lang=js"

import "./Gartenkultur-Company.vue?vue&type=style&index=0&id=7796a67c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7796a67c"]])

export default __exports__